import * as yup from 'yup';
import addressSchema from '@features/workspace/schemas/address-schema';
import { parsePhoneNumber } from 'libphonenumber-js';
import { ensureFirstPlus } from '@utils/formaters';

const userSchema = yup.object().shape({
  person: yup.object().shape({
    title: yup.string().max(20).label('Title'),
    firstName: yup.string().required().max(100).label('First name'),
    lastName: yup.string().required().max(100).label('Last name'),
    nationality: yup.string().required().max(100).label('Nationality'),
    sisAbsentZAIDReason: yup.number().optional().nullable(),
    dateOfBirth: yup.string().required().max(100).label('Date of birth'),
  }),
  position: yup.number().required().label('Major shareholder'),
  identityDocuments: yup.array().of(
    yup.object().shape({
      identityType: yup.string().label('Type of identification'),
      idNumber: yup
        .string()
        .required()
        .min(13)
        .max(13)
        .label('Identification number'),
    })
  ),
  phoneNumber: yup
    .string()
    .required()
    .max(16)
    .label('Phone number')
    .test('is-phone', 'Invalid phone number', (value) => {
      try {
        const parsedPhoneNumber = parsePhoneNumber(ensureFirstPlus(value!));

        return parsedPhoneNumber?.isValid();
      } catch (error) {
        return false;
      }
    }),
  email: yup.string().email().required().max(256).label('Email address'),
  address: addressSchema,
});

export default userSchema;
